import { TeamStanding } from "../../api/client/Api";

export const dataRankingColumns = ["J", "G", "N", "P", "B+", "B-", "D"];

export const getDataRankingConfig = (data: TeamStanding) => [
  {
    title: "J",
    value: data.games_played || "",
  },
  {
    title: "G",
    value: data.games_won || "",
  },
  {
    title: "N",
    value: data.games_drawn || "",
  },
  {
    title: "P",
    value: data.games_lost || "",
  },
  {
    title: "B+",
    value: data.points_scored || "",
  },
  {
    title: "B-",
    value: data.points_conceded || "",
  },
  {
    title: "Diff",
    value: data.points_difference || "",
  },
];
